import { html, LitElement } from 'lit-element';
import { getPercentage } from './utils.js';

/**
 * @element header-block
 * @prop {Object} item - Item
 * @prop {Object} session - session
 * @prop {Object} studentsNumber - students Number
 * @prop {Number} studentsAnsweredNr - The number of all the student that answered the question
 */
export class HeaderBlock extends LitElement {
  static get properties() {
    return {
      item: { type: Object, attribute: false },
      session: { type: Number, attribute: false },
      studentsNumber: { type: Number, attribute: false },
      studentsAnsweredNr: { type: Number, attribute: false },
    };
  }

  createRenderRoot() {
    return this;
  }

  render() {
    const studentsNr = this.studentsNumber || 0;
    const percentage = getPercentage(
      this.studentsNumber,
      this.studentsAnsweredNr
    );

    return html` <div class="header-block">
      <div class="block header-students-number">
        ${studentsNr} Student${studentsNr === 1 ? 's' : ''} (${percentage}%)
      </div>
    </div>`;
  }
}

export default HeaderBlock;
